import type { ReactNode } from "react";

interface TagProps {
  children: ReactNode;
  variant?: "accent" | "primary" | "secondary";
  className?: string;
}

const variantClasses: Record<string, string> = {
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  primary: "bg-primary-100 text-primary-900 border-primary-200",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
};

export default function Tag({ children, variant = "secondary", className = "" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${variantClasses[variant]} ${className}`}
    >
      {children}
    </span>
  );
}